import type { ReactElement } from 'react';
import styles from './PluginConsentGateScreen.module.css';

export interface PluginConsentGateScreenProps {
  /** Texto de finalidade do uso dos dados (aprovado ou fallback neutro —
   * `resolveConsentText`, HUB-201), exibido antes de qualquer interação com
   * o plugin. */
  consentText: string;
  onApprove: () => void;
  onDecline: () => void;
}

/**
 * Tela de consentimento dedicada exibida antes de montar um plugin real
 * (HUB-237, CA-18) — fecha o gap de LGPD do contrato `PluginProps`
 * (ADR-004), que não previa slot de consentimento (mesma classe de achado
 * da HUB-201/218).
 *
 * Recusar **nunca bloqueia a participação** (mesmo padrão da HUB-201): o
 * fluxo segue para o plugin de qualquer forma — a decisão só é usada depois,
 * em `CapturePluginLeadUseCase`, para sanitizar os campos pessoais antes de
 * enfileirar (CA-20).
 */
export function PluginConsentGateScreen({
  consentText,
  onApprove,
  onDecline,
}: PluginConsentGateScreenProps): ReactElement {
  return (
    <section className={styles.container} aria-label="Consentimento de dados">
      <div className={styles.card}>
        <h1 className={styles.title}>Antes de começar</h1>
        <p className={styles.consentNotice}>{consentText}</p>
        <p className={styles.hint}>
          Você pode participar mesmo sem aceitar — seus dados pessoais não serão enviados.
        </p>
        <div className={styles.actions}>
          <button type="button" className={styles.declineButton} onClick={onDecline}>
            Recusar
          </button>
          <button type="button" className={styles.approveButton} onClick={onApprove}>
            Aceitar e continuar
          </button>
        </div>
      </div>
    </section>
  );
}
